export default function PageNotFound(){return/*#__PURE__*/React.createElement("div",null,"Page Not Found");}